import React from "react";
import siteConfig from "../config/siteConfig";

function BrandLogo({ compact = false }) {
  return (
    <span className={`brand-mark${compact ? " brand-mark--compact" : ""}`} aria-hidden="true">
      <svg className="brand-mark__symbol" viewBox="0 0 36 36" focusable="false">
        <rect width="36" height="36" rx="9" />
        <path d="M8 25V11l10 9 10-9v14" />
        <circle cx="18" cy="20" r="1.6" />
      </svg>
      {!compact && (
        <span className="brand-mark__word">
          {siteConfig.brandName.split("").map((letter, index) => (
            <span key={`${letter}-${index}`}>{letter}</span>
          ))}
        </span>
      )}
    </span>
  );
}

export default BrandLogo;
